<!--
  因tabs属性并不包含于options属性之中，故只能跟其他options属性之内的属性值合并设置，此处选择与customClass合并！！
-->

<template>
  <div>
    <!-- collapseItem属性设置 -->
    <el-form-item :label="i18nt('designer.setting.tabPaneSetting')"></el-form-item>
    <el-form-item label-width="0" class="panes-setting">
      <draggable :list="selectedWidget.widgetList" item-key="id" v-bind="{ group: 'panesGroup', ghostClass: 'ghost', handle: '.drag-option' }" @update="dragUpdate">
        <template #item="{ element: tpItem, index: tpIdx }">
          <transition-group name="fade" tag="ul" v-bind:key="tpIdx">
            <!-- 手风琴模式，显示Radio -->
            <template v-if="selectedWidget.options.accordion">
              <li :key="tpIdx" class="col-item">
                <el-radio v-model="selectedWidget.options.expandName" :label="tpItem.id" :value="tpItem.id" style="margin-right: 8px">{{ i18nt('extension.setting.collapseItemExpand') }}</el-radio>
                <el-input type="text" v-model="tpItem.options.title" style="width: 125px"></el-input>
                <i class="iconfont icon-drag drag-option"></i>
                <el-button circle plain size="small" type="danger" @click="itemPropertiesDialogShow(tpItem)" icon="el-icon-more" class="col-delete-button"></el-button>
                <el-button circle plain size="small" type="danger" @click="deleteCollapseItem(selectedWidget, tpIdx)" icon="el-icon-minus" class="col-delete-button"></el-button>
              </li>
            </template>
            <!-- 非手风琴模式，显示Checkbox -->
            <template v-else>
              <el-checkbox-group v-model="selectedWidget.options.expandName" :key="tpIdx">
                <el-checkbox :label="tpItem.options.name" :value="tpItem.options.name" style="margin-right: 2px"
                  >{{ i18nt('extension.setting.collapseItemExpand') }}

                  <el-input type="text" v-model="tpItem.options.title" style="width: 125px"></el-input>
                  <i class="iconfont icon-drag drag-option"></i>
                  <el-button circle plain size="small" type="danger" @click="itemPropertiesDialogShow(tpItem)" icon="el-icon-more" class="col-delete-button"></el-button>
                  <el-button circle plain size="small" type="danger" @click="deleteCollapseItem(selectedWidget, tpIdx)" icon="el-icon-minus" class="col-delete-button"></el-button>
                </el-checkbox>
              </el-checkbox-group>
            </template>
          </transition-group>
        </template>
      </draggable>

      <div>
        <el-button type="primary" link @click="addCollapseItem(selectedWidget)">{{ i18nt('designer.setting.addTabPane') }}</el-button>
      </div>
    </el-form-item>

    <el-dialog :title="i18nt('extension.setting.collapseItemProperyDialogTitle')" v-model="dialogVisible" width="400px" :before-close="itemPropertiesDialogClose">
      <el-form :model="dialogCurrentItemSetting" size="small" label-position="left" label-width="120px" class="setting-form" @submit.prevent>
        <el-form-item :label="i18nt('extension.setting.collapseItemTitle')">
          <el-input type="text" v-model="dialogCurrentItemSetting.title" style="width: 125px"></el-input>
        </el-form-item>
        <el-form-item :label="i18nt('extension.setting.collapseItemValue')">
          <el-input type="text" v-model="dialogCurrentItemSetting.value" style="width: 125px"></el-input>
        </el-form-item>
        <el-form-item :label="i18nt('extension.setting.collapseItemLabel')">
          <el-input type="text" v-model="dialogCurrentItemSetting.label" style="width: 125px"></el-input>
        </el-form-item>
        <el-form-item :label="i18nt('extension.setting.collapseItemBorder')">
          <el-switch v-model="dialogCurrentItemSetting.border"></el-switch>
        </el-form-item>
        <el-form-item :label="i18nt('extension.setting.collapseItemIcon')">
          <el-input type="text" v-model="dialogCurrentItemSetting.icon" style="width: 125px"></el-input>
        </el-form-item>
        <el-form-item :label="i18nt('extension.setting.collapseItemSize')">
          <el-select v-model="dialogCurrentItemSetting.size">
            <el-option label="default" value=""></el-option>
            <el-option label="large" value="large"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="i18nt('extension.setting.collapseItemIsLink')">
          <el-switch v-model="dialogCurrentItemSetting['is-link']"></el-switch>
        </el-form-item>
        <el-form-item :label="i18nt('extension.setting.collapseItemDisabled')">
          <el-switch v-model="dialogCurrentItemSetting.disabled"></el-switch>
        </el-form-item>
        <el-form-item :label="i18nt('extension.setting.collapseItemReadonly')">
          <el-switch v-model="dialogCurrentItemSetting.readonly"></el-switch>
        </el-form-item>
        <el-form-item :label="i18nt('extension.setting.collapseItemLazyRender')">
          <el-switch v-model="dialogCurrentItemSetting['lazy-render']"></el-switch>
        </el-form-item>
        <el-form-item :label="i18nt('extension.setting.collapseItemTitleClass')">
          <el-select v-model="dialogCurrentItemSetting['title-class']" multiple filterable allow-create default-first-option>
            <el-option v-for="(item, idx) in cssClassList" :key="idx" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="i18nt('extension.setting.collapseItemValueClass')">
          <el-select v-model="dialogCurrentItemSetting['value-class']" multiple filterable allow-create default-first-option>
            <el-option v-for="(item, idx) in cssClassList" :key="idx" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="i18nt('extension.setting.collapseItemLabelClass')">
          <el-select v-model="dialogCurrentItemSetting['label-class']" multiple filterable allow-create default-first-option>
            <el-option v-for="(item, idx) in cssClassList" :key="idx" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="itemPropertiesDialogClose">取 消</el-button>
          <el-button type="primary" @click="itemPropertiesDialogConfirm">确 定</el-button>
        </span>
      </template>
    </el-dialog>

    <el-form-item :label="i18nt('extension.setting.collapseAccordion')">
      <el-switch v-model="optionModel.accordion"></el-switch>
    </el-form-item>
  </div>
</template>

<script>
export default {
  componentName: 'PropertyEditor',
  data() {
    return {
      cssClassList: [],
      dialogCurrentItemSetting: {},
      dialogVisible: false,
      expandName: '',
    };
  },
  name: 'collapse-accordion-editor',
};
</script>
<script setup>
import { watch, getCurrentInstance, nextTick } from 'vue';

import { useI18n } from '@/utils/i18n';
import { deepClone, generateId } from '@/utils/util';

const { proxy } = getCurrentInstance();
const props = defineProps({
  designer: Object,
  optionModel: Object,
  selectedWidget: Object,
});

const { i18nt } = useI18n();

nextTick(() => {
  proxy.cssClassList = deepClone(props.designer.getCssClassList());
  //监听表单css代码改动事件并重新加载！
  props.designer.handleEvent('form-css-updated', cssClassList => {
    proxy.cssClassList = cssClassList;
  });
});

watch(
  () => props.selectedWidget.options.accordion,
  val => {
    //如果是手风琴模式，把数组转成字符串
    if (val) {
      props.selectedWidget.options.expandName = '';
    } else {
      props.selectedWidget.options.expandName = [];
    }
  }
);

const onActiveChange = (evt, tpItem) => {
  //TODO: !!!
};

const addCollapseItem = curTabs => {
  const collapseItems = curTabs.widgetList;
  let itemPane = deepClone(props.designer.getContainerByType('collapse-item'));
  itemPane.id = 'collapse-item-' + generateId();
  itemPane.options.name = itemPane.id;
  itemPane.options.label = 'collapse-item-' + (collapseItems.length + 1);
  collapseItems.push(itemPane);

  props.designer.emitHistoryChange();
};

const deleteCollapseItem = (curTabs, tpIdx) => {
  if (curTabs.widgetList.length === 1) {
    proxy.$message.info(this.i18nt('designer.hint.lastPaneCannotBeDeleted'));
    return;
  }

  curTabs.widgetList.splice(tpIdx, 1);
  props.designer.emitHistoryChange();
};

const itemPropertiesDialogShow = collaseItem => {
  proxy.dialogVisible = true;
  proxy.dialogCurrentItemSetting = collaseItem.options;
};

const itemPropertiesDialogClose = () => {
  proxy.dialogVisible = false;
};
const itemPropertiesDialogConfirm = () => {
  proxy.dialogVisible = false;
};

const dragUpdate = () => {};
</script>

<style lang="scss" scoped>
li.col-item {
  list-style: none;

  span.col-span-title {
    display: inline-block;
    font-size: 13px;
    width: 120px;
  }

  .col-delete-button {
    margin-left: 6px;
  }
}

.panes-setting {
  ul {
    padding-inline-start: 0;
    padding-left: 0; /* 重置IE11默认样式 */
    margin: 0;
  }

  .drag-option {
    cursor: move;
  }

  li.ghost {
    background: #fff;
    border: 2px dotted $--color-primary;
  }
}
</style>
